import { Landmark, Globe, Award, MessageCircle } from "lucide-react";

const items = [
  { icon: Landmark, title: "Juristische Tiefe", text: "Tiefgehendes Verständnis des Bank- und Kapitalmarktrechts." },
  { icon: Globe, title: "International", text: "Globales Netzwerk zur Verfolgung von Tätern über Grenzen hinweg." },
  { icon: Award, title: "Expertise", text: "Über 15 Jahre Erfahrung im Bereich Wirtschaftskriminalität." },
  { icon: MessageCircle, title: "Transparenz", text: "Klarheit über Kosten und Chancen von der ersten Minute an." },
];

export function WhyUs() {
  return (
    <section id="warum" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">Warum Veritas Beratung?</h2>
        </div>
        <div className="mt-12 grid gap-8 sm:grid-cols-2 md:grid-cols-4">
          {items.map((it) => (
            <div key={it.title} className="text-center">
              <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-secondary text-navy">
                <it.icon className="h-6 w-6" />
              </div>
              <h3 className="font-semibold">{it.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{it.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}